import {useQuery, gql} from "@apollo/client";
var  HOME_ABOUTUS = gql`
query HomeAboutUs {
    homeAboutUs(where: {localization: {culture_starts_with: "fa"}}) {
      aboutUsImage {
        urls(first: 1)
      }
      htmlBody {
        html
      }
      displayText
    }
  }
`;

export const useHomeAboutUs = () => {
  const {error, loading, data} = useQuery(HOME_ABOUTUS);
  
  return {
    error, data, loading
  };
  } 